<template>
  <div id="nav">
    <router-link :to="{ name: 'MachineList' }">Machine List</router-link> |
    <router-link :to="{ name: 'MachineQueue' }">Machine Queue</router-link> |
    <router-link :to="{ name: 'JobList' }">Job Status</router-link> |
    <router-link :to="{ name: 'JobCreate' }">Create Job</router-link>
  </div>
  <!-- Add burger menu for app navigation -->
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

h4 {
  font-size: 20px;
}
</style>
